// Recovered compiled webpack factory 54652. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      default: function () {
        return s;
      },
      getImageProps: function () {
        return l;
      },
    }));
  let n = r(28140),
    i = r(75040),
    o = r(81356),
    a = n._(r(71124));
  function l(e) {
    let { props: t } = (0, i.getImgProps)(e, {
      defaultLoader: a.default,
      imgConf: {
        deviceSizes: [640, 750, 828, 1080, 1200, 1920, 2048, 3840],
        imageSizes: [16, 32, 48, 64, 96, 128, 256, 384],
        path: "/_next/image",
        loader: "default",
        dangerouslyAllowSVG: !1,
        unoptimized: !1,
      },
    });
    for (let [e, r] of Object.entries(t)) void 0 === r && delete t[e];
    return { props: t };
  }
  let s = o.Image;
}
